import { defineComponent, ref } from "vue";
import { usePortalStore } from "@/framework/portal";
import CircularProgress from "@/plugins/circular-progress/circular-progress.vue";
import _ from "lodash";
import date from 'quasar/src/utils/date/date.js';;

export default defineComponent({
	name: "VisitorDetails",
	inheritAttrs: false,
	components: {
		CircularProgress,
	},
	props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        },
        fields: {
            type: Array as () => Array<any>,
            required: true
        }
	},
	setup() {
		const portal = usePortalStore();
		const groups = portal.getGroups(portal.fields);
		const visitorDetailsForm: any = ref(null);
		portal.visitorFieldsForm = visitorDetailsForm;

		return {
			portal,
			groups,
			visitorDetailsForm,
		};
	},
	mounted() {
		_.forEach(this.fields, fld => {
			// convert multiselect model to array
			if (fld.typeId === 2 && fld.subTypeId === 7 && !Array.isArray(fld.originalValue)) {
				fld.originalValue = !!fld.originalValue && fld.originalValue !== ',' ? fld.originalValue.replace(/(^,)|(,$)/g, '').replace(/\s+/g,'').split(',') : [];
				fld.payloadValue = fld.originalValue;
			}
		})
	},
	methods: {
		validate(val?: any) {			
			_.forEach((<any>this.$refs).visitorDetailsForm, (input) => {
				input.validate().then((success: any) => {
					if (!success) {
						return false;
					}
				});
			});
		},
		validateOptionalDate(value: any) {
			return !value || date.isValid(value) || this.$t('portal_invalidDateMsg');
		},
		validateRequiredDate(value: any) {
			if (!value)
				return !!value || this.$t('portal_requiredMsg');
			return date.isValid(value) || this.$t('portal_invalidDateMsg');			
		},
	},
});
